/* Newsletter VIP Integration JS - weitsicht.swiss (optimiert) */
(function(){
  var COOKIE_DAYS = 7;
  var EXIT_DELAY = 30000;       /* 30 Sekunden statt 3s */
  var BAR_DELAY = 8000;         /* Header-Bar erst nach 8s anzeigen */
  var SCROLL_THRESHOLD = 0.4;   /* Exit-Popup erst nach 40% Scroll */

  function setCookie(n,v,d){var e=new Date();e.setTime(e.getTime()+d*864e5);document.cookie=n+"="+v+";expires="+e.toUTCString()+";path=/;SameSite=Lax";}
  function getCookie(n){var m=document.cookie.match(new RegExp('(^| )'+n+'=([^;]+)'));return m?m[2]:null;}

  /* Track max scroll depth */
  var maxScroll = 0;
  window.addEventListener('scroll', function(){
    var scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
    if(scrolled > maxScroll) maxScroll = scrolled;
  }, {passive: true});

  /* Header Bar - delayed appearance */
  var hb=document.getElementById('ws-nl-header');
  if(hb){
    if(getCookie('ws_nl_bar_closed') || getCookie('ws_nl_subscribed')){
      hb.classList.add('ws-hidden');
      document.body.classList.remove('ws-has-header-bar');
    } else {
      /* Hide initially, show after delay */
      hb.classList.add('ws-hidden');
      document.body.classList.remove('ws-has-header-bar');
      setTimeout(function(){
        if(!getCookie('ws_nl_subscribed')){
          hb.classList.remove('ws-hidden');
          document.body.classList.add('ws-has-header-bar');
        }
      }, BAR_DELAY);
    }
    var cb=hb.querySelector('.ws-nl-close');
    if(cb)cb.addEventListener('click',function(){hb.classList.add('ws-hidden');document.body.classList.remove('ws-has-header-bar');setCookie('ws_nl_bar_closed','1',COOKIE_DAYS);});
  }

  /* Newsletter Forms */
  var forms=document.querySelectorAll('.ws-nl-form');
  forms.forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var email=f.querySelector('input[type="email"]').value;
      if(!email)return;
      var btn=f.querySelector('button');
      var origText=btn.textContent;
      btn.textContent='Wird gesendet...';
      btn.disabled=true;
      fetch('/contact',{
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        body:'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D='+encodeURIComponent(email)+'&contact%5Btags%5D=newsletter,vip,welcome10'
      }).then(function(){
        var sc=f.parentElement.querySelector('.ws-nl-success');
        if(sc){f.style.display='none';sc.style.display='block';}
        else{btn.textContent='\u2713 Angemeldet!';btn.style.background='#2ecc71';btn.style.color='#fff';}
        setCookie('ws_nl_subscribed','1',365);
        setCookie('ws_nl_bar_closed','1',365);
        if(hb){hb.classList.add('ws-hidden');document.body.classList.remove('ws-has-header-bar');}
        if(typeof gtag!=='undefined'){gtag('event','newsletter_signup',{event_category:'Newsletter',event_label:f.closest('[data-nl-source]')?f.closest('[data-nl-source]').dataset.nlSource:'unknown'});}
      }).catch(function(){
        btn.textContent='Fehler - nochmals versuchen';
        btn.disabled=false;
        setTimeout(function(){btn.textContent=origText;},3000);
      });
    });
  });

  /* Exit Intent Popup - only after scroll threshold AND time delay */
  var ep=document.getElementById('ws-nl-exit');
  if(ep&&!getCookie('ws_nl_subscribed')&&!getCookie('ws_nl_exit_shown')){
    var exitShown=false;
    var exitClose=ep.querySelector('.ws-nl-exit-close');
    if(exitClose)exitClose.addEventListener('click',function(){ep.classList.remove('ws-active');setCookie('ws_nl_exit_shown','1',1);});
    ep.addEventListener('click',function(e){if(e.target===ep){ep.classList.remove('ws-active');setCookie('ws_nl_exit_shown','1',1);}});
    function showExit(){
      if(exitShown||getCookie('ws_nl_subscribed'))return;
      ep.classList.add('ws-active');exitShown=true;startCountdown();
    }
    /* Trigger 1: Exit-Intent (Maus verlässt Fenster nach oben) */
    document.addEventListener('mouseleave',function(e){
      if(e.clientY<=0&&maxScroll>=SCROLL_THRESHOLD){showExit();}
    });
    /* Trigger 2: Zeitbasiert nach 30s - NUR Desktop. Auf Mobile/Touch KEIN Auto-Popup (verdeckte sonst die ganze Seite). */
    var isDesktop = window.matchMedia('(min-width:769px)').matches && !('ontouchstart' in window);
    if(isDesktop){ setTimeout(showExit, EXIT_DELAY); }
  }

  /* Countdown */
  function startCountdown(){
    var timer=document.getElementById('ws-nl-timer');
    if(!timer)return;
    var left=300;
    var iv=setInterval(function(){
      left--;
      var m=Math.floor(left/60);var s=left%60;
      timer.textContent=m+':'+(s<10?'0':'')+s;
      if(left<=0){clearInterval(iv);timer.textContent='ABGELAUFEN';}
    },1000);
  }

  /* Header Bar CTA opens exit popup */
  var hbCta=document.querySelector('.ws-nl-header-cta');
  if(hbCta&&ep){hbCta.addEventListener('click',function(){ep.classList.add('ws-active');startCountdown();});}

  /* Copy discount code to clipboard */
  var copyBtns=document.querySelectorAll('.ws-nl-code-copy');
  copyBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var box=btn.closest('.ws-nl-code');
      var code=(box&&box.getAttribute('data-code'))||(box&&box.querySelector('.ws-nl-code-value')?box.querySelector('.ws-nl-code-value').textContent.trim():'');
      if(!code)return;
      var done=function(){var o=btn.textContent;btn.textContent='\u2713 Kopiert';btn.classList.add('ws-copied');setTimeout(function(){btn.textContent=o;btn.classList.remove('ws-copied');},2000);};
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(code).then(done).catch(function(){fallbackCopy(code);done();});
      }else{fallbackCopy(code);done();}
    });
  });
  function fallbackCopy(text){
    try{var ta=document.createElement('textarea');ta.value=text;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.focus();ta.select();document.execCommand('copy');document.body.removeChild(ta);}catch(e){}
  }

  /* Hide elements if already subscribed */
  if(getCookie('ws_nl_subscribed')){
    if(hb){hb.classList.add('ws-hidden');document.body.classList.remove('ws-has-header-bar');}
    var blogs=document.querySelectorAll('.ws-nl-blog');blogs.forEach(function(b){b.style.display='none';});
  }
})();